import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "h-full flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "border-b shadow-lg flex items-center" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-2xl w-full p-4" }, "Maneuvers"),
  /*#__PURE__*/_createVNode("div", { class: "ml-auto flex-shrink-0 flex-grow-0 text-gray-100 w-16 text-sm" }, " MIF "),
  /*#__PURE__*/_createVNode("div", { class: "w-16 flex-shrink-0 flex-grow-0 text-sm mr-1 text-center" }, " Grade ")
], -1)
const _hoisted_3 = { class: "flex items-center w-full" }
const _hoisted_4 = { class: "p-4 w-full text-sm" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "w-16 flex-shrink-0 flex-grow-0" }
const _hoisted_7 = { class: "w-16 flex justify-center" }
const _hoisted_8 = {
  key: 1,
  class: "w-8 h-8 border bg-primary-dark opacity-50 rounded"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_component = _resolveComponent("icon-component")
  const _component_scroll_container = _resolveComponent("scroll-container")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_scroll_container, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.viewModels, (viewModel, index) => {
          return (_openBlock(), _createBlock("button", {
            class: "border-b focus:outline-none w-full",
            key: index,
            onClick: ($event: any) => (_ctx.handleManeuverClick(viewModel))
          }, [
            _createVNode("div", {
              class: ["w-full text-left border-4 border-transparent hover:border-blue-500 flex-shrink-0", {
            'hover:border-highlight border-highlight':
              _ctx.activeManeuver && viewModel.maneuver.name === _ctx.activeManeuver.name
          }]
            }, [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, _toDisplayString(viewModel.maneuver.mif.unFormattedManeuver), 1),
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, _toDisplayString(viewModel.maneuver.mif.value), 1),
                  _createVNode("div", _hoisted_7, [
                    (viewModel.icon)
                      ? (_openBlock(), _createBlock(_component_icon_component, {
                          key: 0,
                          icon: viewModel.icon,
                          class: "w-8 h-8"
                        }, null, 8, ["icon"]))
                      : (_openBlock(), _createBlock("div", _hoisted_8))
                  ])
                ])
              ])
            ], 2)
          ], 8, ["onClick"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}